import React, { FC, ReactElement, useMemo } from 'react';
import TopBarSelect from 'src/components/TopBarSelect';
import { EnviromnentsConnectorsSelectType } from './model';

const EnviromnentsConnectorsSelect: FC<EnviromnentsConnectorsSelectType> = ({
  value,
  onChange,
  stagesStatuses,
}): ReactElement => {
  const options = useMemo(() => {
    const { publish, dev, qc } = stagesStatuses || {
      publish: true,
      dev: true,
      qc: true,
    };

    return [
      {
        id: 'publish',
        value: 'publish',
        disabled: !publish,
        label: 'Publish',
      },
      { id: 'dev', value: 'dev', disabled: !dev, label: 'DEV' },
      { id: 'qc', value: 'qc', disabled: !qc, label: 'QC' },
    ];
  }, [stagesStatuses]);

  return (
    <TopBarSelect
      borderColor='#9E9E9E'
      fontColor='#212121'
      onChange={onChange}
      value={value}
      options={options}
      label='Stage'
    />
  );
};

export default EnviromnentsConnectorsSelect;
